<template>
    <div class="unavailable-page">
        <div class="unavailable">
            We're updating our app.
        </div>
    </div>
</template>

<script>
import { fetchUser } from '@speechki-frontend/core/auth/api/';

export default {
    name: 'UnavailablePage',
    data() {
        return {
            interval: null
        };
    },
    created() {
        if (process.env.VUE_APP_MAINTENANCE) return;

        this.interval = setInterval(() => {
            this.fetchUser();
        }, 8000);
    },
    beforeUnmount() {
        clearInterval(this.interval);
    },
    methods: {
        async fetchUser() {
            try {
                const r = await fetchUser();
                if (r) {
                    window.location = '/';
                }
            } catch (e) {
                //
            }
        }
    }
};
</script>

<style lang="scss" src="./UnavailablePage.scss"></style>
